<template>
	<div class="row form-message__row" v-if="messages" >
		<div class="col-12">
			<div class="alert" :class="'alert-'+message.type" role="alert" :key="'f-message--'+index" v-for="(message, index) in messages"
				v-html="message.message">
			</div>
		</div>
	</div>
</template>
<script>

	export default {
		name: 'form-message',
		props: [
			'scope'
		],
		data() {
			return {}
		},
		computed: {
			messages(){
				return this.$store.getters.getMessage(this.scope);
			}
		},
		methods: {


		}
	}

</script>
<style lang="scss">
	/*.form-message__row{
		width: calc(100% + 30px);
	}*/
</style>